var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 318.232 128.785",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16488",
    "data-name": "Group 16488",
    transform: "translate(-727.716 -1390.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30502",
    "data-name": "Path 30502",
    d: "M729,1059.13c60.761,22.43,79.471,108.859,115.2,114.575s12.976-104.885-12.608-102.87,4.311,108.891,51.47,107.045,47.32-110.786,17.255-110.617-27.827,100.189,27.352,114.479,110.078-16.048,110.078-16.048",
    transform: "translate(0 333)",
    fill: "none",
    stroke: "#96006b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30503",
    "data-name": "Path 30503",
    d: "M1083.34,1182.83s14.956,5.58,24,5.547c-7.357,5.547-11.2,15.839-11.2,15.839",
    transform: "translate(-62.393 308.606)",
    fill: "none",
    stroke: "#96006b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingDesign);
export default __webpack_public_path__ + "static/media/RingDesign.105b4754866e101031e414623a6cbdc2.svg";
export { ForwardRef as ReactComponent };